import React, { Component, Fragment } from "react";

class Terms extends Component {

/*    this.handleScrollButtonClick = this.handleScrollButtonClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.state = {
      text1:"&lt;h1&gt;Hi there!&lt;/h1&gt;"
    };
    */
  htmlDecode(input){
      var e = document.createElement('div');
      e.innerHTML = input;
      return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }

  render() {
    return (
      <Fragment>

  <div style={{ marginTop: "56px" }}>
    <div className="gutter-grid_terms">
      <br />
      <br />
      <br />
      <h2>{this.props.t("titleTerms")}</h2>
      <p>{this.props.t("textTerms")}</p>
      <h3>{this.props.t("title1")}</h3>
      <p>{this.props.t("text1_1")}</p>
      <p><div dangerouslySetInnerHTML={{ __html: this.htmlDecode(this.props.t("text1_2")) }} /></p>
      <p><div dangerouslySetInnerHTML={{ __html: this.htmlDecode(this.props.t("text1_3")) }} /></p>
      <h3>{this.props.t("title2")}</h3>
      <p>{this.props.t("text2_1")}</p>
      <p><div dangerouslySetInnerHTML={{ __html: this.htmlDecode(this.props.t("text2_2")) }} /></p>
      <p>{this.props.t("text2_3")}</p>
      <p>{this.props.t("text2_4")}</p>
      <h3>{this.props.t("title3")}</h3>
      <p>{this.props.t("text3_1")}</p>
      <p><div dangerouslySetInnerHTML={{ __html: this.htmlDecode(this.props.t("text3_2")) }} /></p>
      <h3>{this.props.t("title4")}</h3>
      <p>{this.props.t("text4_1")}</p>
      <p>{this.props.t("text4_2")}</p>
      <p>{this.props.t("text4_3")}</p>
      <h3>{this.props.t("title5")}</h3>
      <p>{this.props.t("text5_1")}</p>
      <p>{this.props.t("text5_2")}</p>
      <p>{this.props.t("text5_3")}</p>
      <h3>{this.props.t("title6")}</h3>
      <p>{this.props.t("text6_1")}</p>
      <p>{this.props.t("text6_2")}</p>
      <p>{this.props.t("text6_3")}</p>
      <h3>{this.props.t("title7")}</h3>
      <p>{this.props.t("text7_1")}</p>
      <br />
      <br />
      <br />
      <br />
    </div>
  </div>
);
</Fragment>
);
}
}

export default Terms;



// WEBPACK FOOTER //
// ./src/components/Terms.js